/* PDP v2 — purchase options (native selling plans) + small buy-panel behaviours.
   Loaded only on templates listed in pdp_v2_suffixes (sections/main-product.liquid).
   No dependencies. Everything is guarded so a missing element is a no-op. */
(function () {
  'use strict';

  function mainForm() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (!forms[i].closest('.sticky-cart__form') && !forms[i].closest('#pdp-sticky-atc')) return forms[i];
    }
    return null;
  }

  function initPurchase() {
    var root = document.querySelector('[data-pv2-purchase]');
    var form = mainForm();
    if (!root || !form) return;

    /* Our selling_plan field lives in the real product form so Dawn's FormData submit
       carries it. Any other selling_plan field (Seal's widget injects one) is removed
       the moment it appears — one field, one source of truth. */
    var field = document.createElement('input');
    field.type = 'hidden';
    field.name = 'selling_plan';
    field.value = '';
    field.setAttribute('data-pv2-field', '');
    form.appendChild(field);

    function purge() {
      var all = form.querySelectorAll('[name="selling_plan"]');
      for (var i = 0; i < all.length; i++) {
        if (!all[i].hasAttribute('data-pv2-field')) all[i].parentNode.removeChild(all[i]);
      }
    }
    purge();
    new MutationObserver(purge).observe(form, { childList: true, subtree: true });

    var options = root.querySelectorAll('[data-pv2-option]');
    var select = root.querySelector('[data-pv2-plan-select]');
    var subPrice = root.querySelector('[data-pv2-sub-price]');
    var pill = root.querySelector('[data-pv2-pill]');
    var desc = root.querySelector('[data-pv2-plan-desc]');
    var oneTimePrice = root.getAttribute('data-one-time-price');
    var oneTimeCompare = root.getAttribute('data-one-time-compare');

    var priceBlock = document.querySelector('.product__info-container .price');
    var regularEl = priceBlock ? priceBlock.querySelector('.price__regular .price-item--regular') : null;
    var saleEl = priceBlock ? priceBlock.querySelector('.price__sale .price-item--sale') : null;
    var compareEl = priceBlock ? priceBlock.querySelector('.price__sale .price-item--regular') : null;
    var badge = priceBlock ? priceBlock.querySelector('.price__badge-sale') : null;
    var wasOnSale = priceBlock ? priceBlock.classList.contains('price--on-sale') : false;
    var originalBadge = badge ? badge.textContent : '';

    function selectedPlan() {
      if (!select) return null;
      return select.options[select.selectedIndex] || null;
    }

    function setHeadline(price, compare, badgeText) {
      if (!priceBlock) return;
      if (compare) {
        priceBlock.classList.add('price--on-sale');
        if (saleEl) saleEl.textContent = price;
        if (compareEl) compareEl.textContent = compare;
        if (badge) badge.textContent = badgeText || originalBadge;
      } else {
        priceBlock.classList.toggle('price--on-sale', wasOnSale);
        if (regularEl) regularEl.textContent = price;
        if (wasOnSale && saleEl) saleEl.textContent = price;
        if (badge) badge.textContent = originalBadge;
      }
    }

    function applyPlan() {
      var opt = selectedPlan();
      if (!opt) return;
      if (subPrice) subPrice.textContent = opt.getAttribute('data-price');
      if (desc) desc.textContent = opt.getAttribute('data-desc');
      if (pill) {
        var t = opt.getAttribute('data-pill');
        pill.textContent = t;
        pill.hidden = !t;
      }
    }

    function choose(which) {
      for (var i = 0; i < options.length; i++) {
        var on = options[i].getAttribute('data-pv2-option') === which;
        options[i].classList.toggle('is-selected', on);
        var input = options[i].querySelector('.pv2-option__input');
        if (input) input.checked = on;
      }
      if (which === 'subscribe') {
        var opt = selectedPlan();
        field.value = opt ? opt.value : '';
        if (opt) setHeadline(opt.getAttribute('data-price'), opt.getAttribute('data-compare'), 'Subscribe & save');
      } else {
        field.value = '';
        setHeadline(oneTimePrice, oneTimeCompare, null);
      }
      root.dispatchEvent(new CustomEvent('pv2:purchase-change', { bubbles: true, detail: { sellingPlan: field.value } }));
    }

    for (var i = 0; i < options.length; i++) {
      (function (el) {
        el.addEventListener('click', function (e) {
          if (e.target.closest('select')) return;
          choose(el.getAttribute('data-pv2-option'));
        });
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(el.getAttribute('data-pv2-option')); }
        });
      })(options[i]);
    }
    if (select) {
      select.addEventListener('change', function () { applyPlan(); choose('subscribe'); });
      select.addEventListener('click', function (e) { e.stopPropagation(); });
    }
    applyPlan();
    choose('onetime');
  }

  /* Move the sticky mobile bar's label to follow the purchase choice, when present. */
  function initStickyLabel() {
    var barBtn = document.querySelector('#pdp-sticky-atc .pdp-sticky-atc__btn');
    var meta = document.querySelector('#pdp-sticky-atc [data-sticky-meta]');
    if (!barBtn) return;
    document.addEventListener('pv2:purchase-change', function (e) {
      if (!barBtn.disabled) barBtn.textContent = e.detail.sellingPlan ? 'Subscribe' : 'Add to cart';
      if (meta) {
        var sel = document.querySelector('[data-pv2-plan-select]');
        var plan = sel && sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].text : '';
        meta.textContent = e.detail.sellingPlan ? ('Subscribe & save · ' + plan) : 'One-time purchase';
      }
    });
  }

  /* Main add-to-cart label follows the choice too, so a recurring charge is never a surprise. */
  function initAtcLabel() {
    var form = mainForm();
    var btn = form ? form.querySelector('[name="add"]') : null;
    if (!btn) return;
    var span = btn.querySelector('span') || btn;
    var original = span.textContent.trim();
    document.addEventListener('pv2:purchase-change', function (e) {
      if (btn.disabled) return;
      span.textContent = e.detail.sellingPlan ? 'Subscribe' : original;
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () { initPurchase(); initStickyLabel(); initAtcLabel(); });
})();
